import ArticleLayout from "../components/ArticleLayout";

export default function BagsGuide() {
  return <ArticleLayout articleId={12} />;
}